export enum GroupIdType {
    Statistical = 'C0002',
    Functional = 'C0003',
    Advertising = 'C0004',
    EmbeddedContent = 'C0008'
}

export interface ConsentChangedEventObjectType {
    detail?: GroupIdType[] | any;
}
